// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   CreatingAssetView Styles
   
   Design System: Uses CSS variables from colors.css
   - Flat surfaces with borders (no gradients)
   - Minimal/no corner radii
   - Compact and simple layout
   ====================== */

/* ======================
   BASE LAYOUT
   ====================== */

.creating-asset-view {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-canvas-surface);
  padding: 24px;
}

/* ======================
   CLOSE BUTTON
   ====================== */

.creating-asset-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.15s ease;
  z-index: 10;
  padding: 0;
}

.creating-asset-close-btn:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
  border-color: var(--color-text-secondary);
}

/* ======================
   CONTENT
   ====================== */

.creating-asset-content {
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ======================
   HEADER
   ====================== */

.creating-asset-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.creating-asset-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  letter-spacing: 0.2px;
}

.creating-asset-hint {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-secondary);
}

/* ======================
   GENERATING STATE
   ====================== */

.creating-asset-generating {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 0;
}

.creating-asset-spinner {
  color: var(--color-text-secondary);
  animation: creating-asset-spin 1s linear infinite;
}

@keyframes creating-asset-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.creating-asset-generating-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

/* ======================
   RESPONSIVE
   ====================== */

@media (max-width: 640px) {
  .creating-asset-view {
    padding: 16px;
  }

  .creating-asset-content {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/canvas-modes/CreatingAssetView.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;2BAE2B;;AAE3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ======================\n   CreatingAssetView Styles\n   \n   Design System: Uses CSS variables from colors.css\n   - Flat surfaces with borders (no gradients)\n   - Minimal/no corner radii\n   - Compact and simple layout\n   ====================== */\n\n/* ======================\n   BASE LAYOUT\n   ====================== */\n\n.creating-asset-view {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg-canvas-surface);\n  padding: 24px;\n}\n\n/* ======================\n   CLOSE BUTTON\n   ====================== */\n\n.creating-asset-close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  z-index: 10;\n  padding: 0;\n}\n\n.creating-asset-close-btn:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n  border-color: var(--color-text-secondary);\n}\n\n/* ======================\n   CONTENT\n   ====================== */\n\n.creating-asset-content {\n  width: 100%;\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ======================\n   HEADER\n   ====================== */\n\n.creating-asset-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: center;\n}\n\n.creating-asset-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  letter-spacing: 0.2px;\n}\n\n.creating-asset-hint {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n/* ======================\n   GENERATING STATE\n   ====================== */\n\n.creating-asset-generating {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 32px 0;\n}\n\n.creating-asset-spinner {\n  color: var(--color-text-secondary);\n  animation: creating-asset-spin 1s linear infinite;\n}\n\n@keyframes creating-asset-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.creating-asset-generating-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n/* ======================\n   RESPONSIVE\n   ====================== */\n\n@media (max-width: 640px) {\n  .creating-asset-view {\n    padding: 16px;\n  }\n\n  .creating-asset-content {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
